import React, { useState } from "react";

// IMPORTE AQUI as imagens (ajuste os caminhos/nome de arquivo conforme sua pasta)
import img2000 from "../../assets/images/conquistas/trofeus-2000.png";
import img2002 from "../../assets/images/conquistas/trofeus-2002.png";
import img2003_2004 from "../../assets/images/conquistas/trofeus-2004-2003.png";
import img2009_2010 from "../../assets/images/conquistas/trofeus-2010-2009.png";
import img2013_2014 from "../../assets/images/conquistas/trofeus-2014-2013.png";
import img2016_2017 from "../../assets/images/conquistas/trofeus-2017-2016.png";
import img2019_2020 from "../../assets/images/conquistas/trofeus-2020-2019.png";
import img2020 from "../../assets/images/conquistas/trofeus-2022.png";
import img2024 from "../../assets/images/conquistas/trofeus-2024.png";
import img20242 from "../../assets/images/conquistas/trofeus-2024-PrimeiroLugar.png";

const defaultItems = [
  {
    id: 1,
    title: "2000",
    period: "Conquista - Águias de Bronze da Bradesco Seguros",
    image: img2000,
    alt: "Troféu 2000",
  },
  {
    id: 2,
    title: "2002",
    period:
      "Campeão da Bradesco Vida e Previdência<br />Períodos: Março, Maio e Junho",
    image: img2002,
    alt: "Troféu 2002",
  },
  {
    id: 3,
    title: "2003 a 2004",
    period:
      "2003 - Concessionário na Bradesco Seguros <br />2004 - Concessionário na Bradesco Seguros",
    image: img2003_2004,
    alt: "Troféu 2003-2004",
  },
  {
    id: 4,
    title: "2009 a 2011",
    period:
      "2009 - Campeões Sulamérica <br /> 2010 - Campeões Sulamérica <br /> 2011 - Campeões Porto Seguro",
    image: img2009_2010,
    alt: "Troféu 2009-2010",
  },
  {
    id: 5,
    title: "2013 a 2014",
    period:
      "2013 - Premio Destak Empresarial - São Gotardo/MG <br /> 2014 - Campeão Mapfre DNA - Las Vegas",
    image: img2013_2014,
    alt: "Troféu 2013-2014",
  },
  {
    id: 6,
    title: "2016 a 2017",
    period:
      "2016 - Campeão Mapfre DNA - New York <br />2017 - Campeão Conquistadores Porto Seguro",
    image: img2016_2017,
    alt: "Troféu 2016-2017",
  },
  {
    id: 7,
    title: "2019 a 2020",
    period:
      "2019 - Destaque Conquistadores Porto Seguro <br /> 2019 - 2º Lugar Porto Seguro (Top 10 - Previdencia)<br />2020 - 1º Lugar Porto Seguro (Top 10 - Previdencia)<br />2020 - 2º Lugar Porto Seguro (Top 10 - Previdencia)",
    image: img2019_2020,
    alt: "Troféu 2019-2020",
  },
  {
    id: 8,
    title: "2022",
    period: "2022 - Conquistadores Porto Seguro (1º Quadrimestre)",
    image: img2020,
    alt: "Troféu 2020",
  },
  {
    id: 9,
    title: "2024",
    period:
      "2024 - 1º Lugar no Conquistadores Porto Seguro (1º Quadrimestre) <br />2024 - 2º Lugar no Conquistadores Porto Seguro (2º Quadrimestre)",
    image: img2024,
    alt: "Troféu 2024",
  },
  {
    id: 10,
    title: "2024",
    period: "2024 - 1º Lugar no Conquistadores Porto Seguro ",
    image: img20242,
    alt: "Troféu 2024",
  },
];

const AchievementsTimeline = ({ items = defaultItems }) => {
  const [active, setActive] = useState(null);

  if (!items || items.length === 0) {
    return (
      <div className="py-12">
        <p className="text-center text-gray-500">
          Nenhuma conquista cadastrada ainda.
        </p>
      </div>
    );
  }

  return (
    <section>
      <div className="container mx-auto">
        <div className="bg-white shadow-lg rounded-lg overflow-hidden mx-auto p-8">
          <h2 className="text-center text-3xl sm:text-4xl font-bold text-blue-950 mb-6 max-w-5xl mx-auto">
            Nossas Conquistas
          </h2>
          <div className="space-y-6 max-w-5xl mx-auto pb-12">
            <p className="text-lg sm:text-xl text-blue-950 text-justify">
              Uma das corretoras{" "}
              <span className="font-bold">
                mais premiadas de Minas Gerais e do Brasil
              </span>
              .<br /> Com a Free Market, você{" "}
              <span className="font-bold">
                garante qualidade, transparência e solidez
              </span>{" "}
              no serviço prestado, além da certeza de receber{" "}
              <span className="font-bold">100% da sua indenização</span>.
              Confira algumas das principais conquistas que alcançamos nos
              últimos 20 anos.
            </p>
          </div>

          <div className="max-w-4xl mx-auto px-2">
            <div className="relative">
              <div className="hidden md:block absolute left-1/2 transform -translate-x-1/2 h-full w-1 bg-blue-100"></div>

              <ul className="space-y-8 md:space-y-12">
                {items.map((it, idx) => {
                  const side = idx % 2 === 0 ? "left" : "right";

                  return (
                    <li key={it.id || idx} className="relative">
                      <div
                        className="bg-white border shadow-md rounded-xl p-12 flex flex-col items-center text-center cursor-pointer hover:shadow-lg transition"
                        onClick={() => setActive(it)}
                      >
                        <div className="w-full max-w-sm h-64 overflow-hidden rounded-lg mb-4">
                          <img
                            src={it.image}
                            alt={it.alt || it.title}
                            loading="lazy"
                            className="object-contain w-full h-full"
                          />
                        </div>
                        <h4 className="font-semibold text-blue-950">
                          {it.title}
                        </h4>
                        {it.period && (
                          <p
                            className="text-sm text-gray-500 mt-1"
                            dangerouslySetInnerHTML={{ __html: it.period }}
                          />
                        )}
                      </div>

                      <div className="hidden md:block absolute top-6 left-1/2 transform -translate-x-1/2 w-4 h-4 flex items-center justify-center">
                        <div className="w-3 h-3 rounded-full bg-blue-600 border-4 border-white shadow" />
                      </div>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>

          {active && (
            <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
              <div
                className="absolute inset-0 bg-black/60"
                onClick={() => setActive(null)}
              ></div>

              <div className="relative max-w-4xl w-full bg-white rounded-lg shadow-lg overflow-hidden">
                <button
                  onClick={() => setActive(null)}
                  className="absolute top-3 right-3 z-10 bg-white rounded-full p-2 shadow hover:opacity-90"
                  aria-label="Fechar"
                >
                  ✕
                </button>

                <div className="flex flex-col md:flex-row items-stretch">
                  <div className="md:w-2/3 w-full h-80 md:h-auto">
                    <img
                      src={active.image}
                      alt={active.alt || active.title}
                      className="w-full h-full object-contain bg-gray-50"
                    />
                  </div>
                  <div className="md:w-1/3 p-6">
                    <h4 className="text-xl font-semibold text-blue-950">
                      {active.title}
                    </h4>
                    {active.period && (
                      <p
                        className="text-sm text-gray-500 mt-2"
                        dangerouslySetInnerHTML={{ __html: active.period }}
                      />
                    )}
                    {active.description && (
                      <p className="mt-4 text-gray-700">{active.description}</p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default AchievementsTimeline;
